import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import { SettingsProvider } from "@/context/SettingsContext";
import { AuthProvider } from "@/context/AuthContext";

import Home from "@/pages/Home";
import Promozioni from "@/pages/Promozioni";
import BookmakerPage from "@/pages/BookmakerPage";
import ComeFunziona from "@/pages/ComeFunziona";
import Community from "@/pages/Community";
import LavoraConNoi from "@/pages/LavoraConNoi";
import Contatti from "@/pages/Contatti";
import Privacy from "@/pages/legal/Privacy";
import Cookie from "@/pages/legal/Cookie";
import Termini from "@/pages/legal/Termini";
import GiocoResponsabile from "@/pages/legal/GiocoResponsabile";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import RequireAuth from "@/pages/admin/RequireAuth";

function App() {
  return (
    <div className="App">
      <SettingsProvider>
        <AuthProvider>
          <BrowserRouter>
            <Toaster theme="dark" position="top-center" richColors />
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/promozioni" element={<Promozioni />} />
                <Route path="/bookmaker" element={<BookmakerPage />} />
                <Route path="/come-funziona" element={<ComeFunziona />} />
                <Route path="/community" element={<Community />} />
                <Route path="/lavora-con-noi" element={<LavoraConNoi />} />
                <Route path="/contatti" element={<Contatti />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/cookie" element={<Cookie />} />
                <Route path="/termini" element={<Termini />} />
                <Route path="/gioco-responsabile" element={<GiocoResponsabile />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <RequireAuth>
                    <AdminDashboard />
                  </RequireAuth>
                }
              />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SettingsProvider>
    </div>
  );
}

export default App;
